import {ComponentRef, Injectable} from '@angular/core';
import {GoldenLayoutComponent} from 'ngx-golden-layout';
import GoldenLayout, {ComponentConfig, ContentItem, ItemConfig} from 'golden-layout';

@Injectable({
  providedIn: 'root'
})
export class LayoutService {

  private _layout: GoldenLayoutComponent;
  private lastRow: string = null;

  constructor() {
  }

  set layout(value: GoldenLayoutComponent) {
    this._layout = value;
  }

  get layout(): GoldenLayoutComponent {
    return this._layout;
  }

  focus(name: string) {
    this.layout.focusComponent(name);
  }

  openTab(config: GoldenLayout.ComponentConfig, near?: string): Promise<ComponentRef<any>> {
    const id: string = config.id as string || null;
    if (id && this.layout.getComponents()[id]) {
      this.focus(id);
      return null;
    }
    return this.layout.createNewComponent(config, near);
  }

  openComplexTab(config: GoldenLayout.ItemConfigType, index = 1): ContentItem {

    // Get the main stack
    const root = this.layout.getGoldenLayoutInstance().root;
    const mainStack = root.getItemsById('main-stack')[0];

    // Add child
    mainStack.addChild(config, index);

    const newItem = mainStack.contentItems[index];

    // Close all
    // @ts-ignore
    newItem.tab.closeElement.off().on('click', newItem, (e) => {
      e.preventDefault();
      (e.data as ContentItem).remove();
    });
    return newItem;
  }
}
